import { css } from 'styled-components';

export function getTransition(transition: string, delay?: string) {
  return css`
    transition: ${transition};
    transition-delay: ${delay};
    transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  `;
}
